import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

import styles from "./ConfirmModal.module.css";

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  title = "Confirm",
  confirmLabel = "Yes",
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} title={title} width={500}>
      <div className={styles.body}>
        <p className={styles.message}>{message}</p>
        <div className={styles.footer}>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
